export default "__VITE_ASSET__D7CS7WQR__"